// LogoutConfirmationModal.tsx
import React, { useEffect, useState } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import { useNavigate } from 'react-router-dom';

interface LogoutConfirmationModalProps {
    isOpen?: boolean;
    onToggle?: () => void;
}

const LogoutConfirmationModal: React.FC<LogoutConfirmationModalProps> = ({ 
    isOpen: externalIsOpen, 
    onToggle: externalOnToggle 
}) => {
    const navigate = useNavigate();
    const [internalIsOpen, setInternalIsOpen] = useState(false);
    const [pendingLogout, setPendingLogout] = useState(false);

    const isOpen = externalIsOpen !== undefined ? externalIsOpen : internalIsOpen;
    const onToggle = externalOnToggle || (() => setInternalIsOpen(!internalIsOpen));

    const handleLogout = () => {
        setPendingLogout(true);
        // Clear all auth data
        localStorage.removeItem("accessToken");
        localStorage.removeItem("refreshToken");
        localStorage.removeItem("user");
        
        // Close modal
        onToggle();
        
        // Navigate to login page
        setTimeout(() => {
            navigate("/login");
            setPendingLogout(false);
        }, 100);
    };

    const handleCancel = () => {
        onToggle();
    };

    useEffect(() => {
        // Listen for custom logout event
        const handleShowLogoutModal = (event: any) => {
            setInternalIsOpen(true);
        };

        window.addEventListener('showLogoutModal', handleShowLogoutModal);

        return () => {
            window.removeEventListener('showLogoutModal', handleShowLogoutModal);
        };
    }, []);

    return (
        <Modal isOpen={isOpen} toggle={onToggle} centered>
            <ModalHeader toggle={onToggle}>
                <h5 className="modal-title">Confirm Logout</h5>
            </ModalHeader>
            <ModalBody>
                <div className="text-center">
                    <div className="mb-3">
                        <i className="ri-logout-box-line" style={{ fontSize: '48px', color: '#f46a6a' }}></i>
                    </div>
                    <h5>Are you sure you want to logout?</h5>
                    <p className="text-muted">You will be redirected to the login page.</p>
                </div>
            </ModalBody>
            <ModalFooter>
                <Button color="light" onClick={handleCancel} disabled={pendingLogout}>
                    Cancel
                </Button>
                <Button color="danger" onClick={handleLogout} disabled={pendingLogout}>
                    {pendingLogout ? 'Logging out...' : 'Yes, Logout'}
                </Button>
            </ModalFooter>
        </Modal>
    );
};

export default LogoutConfirmationModal;